import { fallback, maxValue, minValue, number, pipe } from 'valibot'

export const PIXELATION_SHADER_INTENSITY_VALUE_STEP : number = 1
export const PIXELATION_SHADER_INTENSITY_VALUE_MIN : number = 0
export const PIXELATION_SHADER_INTENSITY_VALUE_MAX : number = 30
export const PIXELATION_SHADER_INTENSITY_VALUE_DEFAULT : number = 0

export const PixelationShaderIntensityValueSchema = fallback(pipe(number(),
  minValue(PIXELATION_SHADER_INTENSITY_VALUE_MIN),
  maxValue(PIXELATION_SHADER_INTENSITY_VALUE_MAX),
  ), PIXELATION_SHADER_INTENSITY_VALUE_DEFAULT)
